import * as actions from "../cap17drive/actions";
import reducer from "../cap17drive/reducer";
import * as selectors from "../cap17drive/selectors";

export default {actions, reducer, selectors};
